import { render, staticRenderFns } from "./repairData.vue?vue&type=template&id=80c9855c&scoped=true&"
import script from "./repairData.vue?vue&type=script&lang=js&"
export * from "./repairData.vue?vue&type=script&lang=js&"
import style0 from "./repairData.vue?vue&type=style&index=0&id=80c9855c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c9855c",
  null
  
)

export default component.exports